import { resourcesList } from './resources/resources-list';
import { resourcesAlgoliaSearch } from './resources/resources-algolia-search';

jQuery(document).ready(function($){
  resourcesList($)
  resourcesAlgoliaSearch($)

  /**
   * Since Beaver Builder after save/publish returns html string via ajax our js functions get 'dead' as they are expected to be loaded on 'document ready' event.
   * This results in 'load more', 'filters', 'category filter', 'autocomplete search box' etc. stop working.
   * To fix that we init our frontend functions on 'didRenderLayoutComplete' Beaver Builder hook.
   * @see bb-plugin\js\fl-builder.js, '_bindEvents' function.
   *
   * TODO - see if there is a more elegant way to solve this
   */
  $( 'body' ).on( 'fl-builder.didRenderLayoutComplete', function(){
    window.resourcesList.init.constructor()
    window.AlgoliaSearch.algoliaSearch()
    window.AlgoliaSearch.algoliaAutocompleteSearch()
  });
});
